export default __webpack_public_path__ + "static/media/Plus-rounded.591ecdf2.svg";